import { Row, Col } from "antd";
import React from "react";
import Box from "../../../../components/Box/Box";
import DateRangeDropdown from "../../../../components/Dashboard/DateRangeDropdown";
import ReusableTable from "../../../../components/TableComponent";
import HeadingSubHeading from "../../../../components/ViewHeading/HeadingSubHeading";
import { MasterConfigs } from "../../../../interfaces/entity";
import AvgWorkHoursLeaderboard from "./MostHourWorked/AvgWorkHoursLeaderboard";

const OvertimeHours = () => {
    const config: MasterConfigs = {
        title: 'Most Hour Worked',
        api: () => '/most-hour-worked',
        modalTitle: (text) => `Add`,
        getColumns: () => [
            {
                title: 'Employee',
                dataIndex: 'employee',
                key: 'employee',
                render: (text) => text
            }, {
                title: 'Business Unit',
                dataIndex: 'businessUnit',
                key: 'businessUnit',
                render: (text) => text
            }, {
                title: 'Department',
                dataIndex: 'department',
                key: 'department',
                render: (text) => text
            }, {
                title: 'Location',
                dataIndex: 'location',
                key: 'location',
                render: (text) => text
            }, {
                title: 'Total Work Hours',
                dataIndex: 'totalWorkHours',
                key: 'totalWorkHours',
                render: (text) => text
            }, {
                title: 'Avg Work Hours / Day',
                dataIndex: 'avgWorkHoursPerDay',
                key: 'avgWorkHoursPerDay',
                render: (text) => text
            }
        ]
    }

    return <Row gutter={[16, 16]}>
        <Col span={24}>
            <HeadingSubHeading titleProps={{ level: 5 }} title="Avg. Over Time Hours Leaderboard" />
        </Col>
        <Col span={24}>
            <Box title="Most Over Time Hours Worked by Department" actions={<DateRangeDropdown />}>
                <AvgWorkHoursLeaderboard />
            </Box>
        </Col>
        <Col span={24}>
            <ReusableTable config={config} />
        </Col>
    </Row>
}

export default OvertimeHours;